// frontend/src/services/orc.service.ts

import api from './api';
import type { ORCRequest, ORCResponse } from '../interfaces/orc.interface';

export const orcService = {
  /**
   * Executa o pipeline ORC.
   * Envia o payload e devolve a resposta crua do backend:
   *   { success, trace_id, correlationId, message }
   */
  async process(request: ORCRequest): Promise<ORCResponse> {
    const response = await api.post('/orc/run', request);
    return response.data;
  },
};